module.exports = __webpack_public_path__ + "static/tacoma1-3c4e1cb5cd9101c6809b5cf5eaf44eb1.png";